import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import{HttpClientModule} from '@angular/common/http';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { HomeComponent } from './home/home.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { EmponboardingformComponent } from './emponboardingform/emponboardingform.component';
import { CheckerreviewComponent } from './checkerreview/checkerreview.component';
import { FinalapproverComponent } from './finalapprover/finalapprover.component';
import { AccountcreationComponent } from './accountcreation/accountcreation.component';
import { HrclosureComponent } from './hrclosure/hrclosure.component';
import { ToastrModule } from 'ngx-toastr';
import { MatNativeDateModule } from '@angular/material/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { EmployeemasterComponent } from './employeemaster/employeemaster.component';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { EmpMastergridComponent } from './Master/emp-mastergrid/emp-mastergrid.component';
//import { CheckerdataComponent } from './checkergrid/checkerdata/checkerdata.component';
import { CheckerdataComponent } from './checkerreview/checkerdatagrid/checkerdata/checkerdata.component';
import { FinalApprovalDataComponent } from './finalapprover/FinalApprovalGrid/final-approval-data/final-approval-data.component';
import { EnterFocusDirective } from './directives/enter-focus.directive';
import { ITgridComponent } from './accountcreation/ITcreationGrid/itgrid/itgrid.component';
import { HRclosureGridComponent } from './hrclosure/HrclosureGrid/hrclosure-grid/hrclosure-grid.component';
import { EmponboardingGridComponent } from './emponboardingform/emponboardingGrid/emponboarding-grid/emponboarding-grid.component';
import { ITfacilityRequestComponent } from './Transaction/itfacility-request/itfacility-request.component';
import { CheckItFacilityGridComponent } from './checkerreview/CheckerITfacilityGrid/check-it-facility-grid/check-it-facility-grid.component';
import { CheckerItFacilityComponent } from './checkerreview/CheckITfacilityform/checker-it-facility/checker-it-facility.component';
import { FinalitfacilityComponent } from './finalapprover/FinalITfacilitygrid/finalitfacility/finalitfacility.component';
import { FinalitfacilityrequestformComponent } from './finalitfacilityrequestform/finalitfacilityrequestform.component';
import { ITfacilitycloserComponent } from './Transaction/ITFacilityclosure/itfacilitycloser/itfacilitycloser.component';
import { MicrosoftITfacilityformComponent } from './Transaction/Microsoft360forms/MicrosoftITfacilityform/microsoft-itfacilityform/microsoft-itfacilityform.component';
import { MicrosoftItfacilitygridComponent } from './Transaction/Microsoft360forms/MicrosoftITfacilityform/microsoft-itfacilityform/MicrosoftitfacilityGrid/microsoft-itfacilitygrid/microsoft-itfacilitygrid.component';
import { MicroFinalapprGridComponent } from './Transaction/Microsoft360forms/MicrosoftITfacilityform/MicrosoftFinal_approveform/Microsoftfinalappr_Grid/micro-finalappr-grid/micro-finalappr-grid.component';
import { MicroFinalapproverComponent } from './Transaction/Microsoft360forms/MicrosoftITfacilityform/MicrosoftFinal_approveform/Microsoft_finalapprove/micro-finalapprover/micro-finalapprover.component';
import { MicroItfacilityClosurComponent } from './Transaction/Microsoft360forms/MicrosoftITfacilityform/MicrosoftITfacilitycloser/micro-itfacility-closur/micro-itfacility-closur.component';
import { ITfacilityRejectionformComponent } from './Transaction/ITFacilityRejectedform/ITfacilityrejectionform/itfacility-rejectionform/itfacility-rejectionform.component';
import { ItFacilityRejectionGridComponent } from './Transaction/ITFacilityRejectedform/ITfacilityrejectiongrid/it-facility-rejection-grid/it-facility-rejection-grid.component';
import { MicrosoftRejectionformComponent } from './Transaction/Microsoft360forms/Microsoft_DynamicRejection/Microsoft-Rejection/microsoft-rejectionform/microsoft-rejectionform.component';
import { MicrosoftRejectionGridComponent } from './Transaction/Microsoft360forms/Microsoft_DynamicRejection/microsoft-rejectionform/microsoft-rejection-grid/microsoft-rejection-grid.component';
import { TicketCheckerApproverComponent } from './Transaction/Tickets/TicketsCheckerApprover/ticket-checker-approver/ticket-checker-approver.component';
import { TicketCreationComponent } from './Transaction/Tickets/TicketCreation/ticket-creation/ticket-creation.component';
import { ITfacilitycheckerDeclineComponent } from './Transaction/ITFacilityRejectedform/ITfacilityCheckerDeclineform/itfacilitychecker-decline/itfacilitychecker-decline.component';
import { ITfacilitycheckerDeclineGridComponent } from './Transaction/ITFacilityRejectedform/ITfacilityCheckerDeclineform/ITfacilityChecker-Declinegrid/itfacilitychecker-decline-grid/itfacilitychecker-decline-grid.component';
import { CheckerItfacilityRejgridComponent } from './checkerreview/CheckerITfacilityGrid/CheckerItfacilityRejection/Grid/checker-itfacility-rejgrid/checker-itfacility-rejgrid.component';
import { CheckerItfacilityRejformComponent } from './checkerreview/CheckerITfacilityGrid/CheckerItfacilityRejection/form/checker-itfacility-rejform/checker-itfacility-rejform.component';
import { FinalItfacilityRejformComponent } from './Transaction/itfacility-request/finalItFacilityRejection/FinalIt-FacilityRej-form/final-itfacility-rejform/final-itfacility-rejform.component';
import { FinalItFacilityRejgridComponent } from './Transaction/itfacility-request/finalItFacilityRejection/FinalIt-FacilityRej-grid/final-it-facility-rejgrid/final-it-facility-rejgrid.component';
import { MicrosCheckerRejgridComponent } from './Transaction/Microsoft360forms/Microsoft_DynamicRejection/MicrosoftCheckerRejection/MicrosoftCheckerGrid/micros-checker-rejgrid/micros-checker-rejgrid.component';
import { MicrosoftCheckerrejformComponent } from './Transaction/Microsoft360forms/Microsoft_DynamicRejection/MicrosoftCheckerRejection/Microsoftchecker-Rejform/microsoft-checkerrejform/microsoft-checkerrejform.component';
import { ITReviewGridComponent } from './Transaction/Tickets/ITReviewforms/ITReviewGrid/itreview-grid/itreview-grid.component';
import { ITReviewformComponent } from './Transaction/Tickets/ITReviewforms/ITReviewform/itreviewform/itreviewform.component';
import { ITFacilityRevokeComponent } from './Transaction/ITFacility-Revokeform/ITFacility-Revokeform/itfacility-revoke/itfacility-revoke.component';
import { ITfacilityRevokeGridComponent } from './Transaction/ITFacility-Revokeform/ITFacility-RevokeGrid/itfacility-revoke-grid/itfacility-revoke-grid.component';
import { ITFacilityRevokeCheckerComponent } from './Transaction/ITFacility-Revokeform/ITFacility-RevokeCheckerApprover/itfacility-revoke-checker/itfacility-revoke-checker.component';
import { ITFacilityRevokeFinalApproverComponent } from './Transaction/ITFacility-Revokeform/ITFacility-RevokeFinalApprover/itfacility-revoke-final-approver/itfacility-revoke-final-approver.component';
import { ITFacilityRevokeReviewComponent } from './Transaction/ITFacility-Revokeform/ITFacility-RevokeCheckerApprover/ITFacility-Revokereview/itfacility-revoke-review/itfacility-revoke-review.component';
import { ITFacilityRevokeFinalApproverGridComponent } from './Transaction/ITFacility-Revokeform/ITFacility-RevokeFinalApprover/ITFacility-RevokeFinalapprover/itfacility-revoke-final-approver-grid/itfacility-revoke-final-approver-grid.component';
import { MaintainceTicketFormComponent } from './Transaction/Maintaince-Ticket/Maintaince-Ticketform/maintaince-ticket-form/maintaince-ticket-form.component';
import { TicketStatusReviewComponent } from './Transaction/Tickets/Ticket-StatusReview/ticket-status-review/ticket-status-review.component';
import { ITEmployeeReviewFormComponent } from './Transaction/Tickets/ITReviewforms/ITEmployeeReviewform/itemployee-review-form/itemployee-review-form.component';
import { UserMasterComponent } from './Settings/User_Master/user-master/user-master.component';
import { UserMasterGridComponent } from './Settings/User_MasterGrid/user-master-grid/user-master-grid.component';
import { MenumasterComponent } from './Setting/menumaster/menumaster.component';
import { MenuMasterComponent } from './Settings/menu-master/menu-master.component';
import { MenumasterGridComponent } from './Settings/menumaster-grid/menumaster-grid.component';
import { ReferenceMasterComponent } from './Master/Reference-master/reference-master/reference-master/reference-master.component';
import { ReferenceDetailsComponent } from './Master/Reference-master/reference-master-grid/reference-details/reference-details.component';



@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    HomeComponent,
    DashboardComponent,
    EmponboardingformComponent,
    CheckerreviewComponent,
    FinalapproverComponent,
    AccountcreationComponent,
    HrclosureComponent,
    EmployeemasterComponent,
    EmpMastergridComponent,
    
    CheckerdataComponent,
    
    FinalApprovalDataComponent,
    
    EnterFocusDirective,
    ITgridComponent,
    HRclosureGridComponent,
    EmponboardingGridComponent,
    ITfacilityRequestComponent,
    CheckItFacilityGridComponent,
    CheckerItFacilityComponent,
    FinalitfacilityComponent,
    FinalitfacilityrequestformComponent,
    ITfacilitycloserComponent,
    MicrosoftITfacilityformComponent,
    MicrosoftItfacilitygridComponent,
    MicroFinalapprGridComponent,
    MicroFinalapproverComponent,
    MicroItfacilityClosurComponent,
    ITfacilityRejectionformComponent,
    ItFacilityRejectionGridComponent,
    MicrosoftRejectionformComponent,
    MicrosoftRejectionGridComponent,
    TicketCheckerApproverComponent,
    TicketCreationComponent,
    ITfacilitycheckerDeclineComponent,
    ITfacilitycheckerDeclineGridComponent,
    CheckerItfacilityRejgridComponent,
    CheckerItfacilityRejformComponent,
    FinalItfacilityRejformComponent,
    FinalItFacilityRejgridComponent,
    MicrosCheckerRejgridComponent,
    MicrosoftCheckerrejformComponent,
    ITReviewGridComponent,
    ITReviewformComponent,
    ITFacilityRevokeComponent,
    ITfacilityRevokeGridComponent,
    ITFacilityRevokeCheckerComponent,
    ITFacilityRevokeFinalApproverComponent,
    ITFacilityRevokeReviewComponent,
    ITFacilityRevokeFinalApproverGridComponent,
    MaintainceTicketFormComponent,
    TicketStatusReviewComponent,
    ITEmployeeReviewFormComponent,
    UserMasterComponent,
    UserMasterGridComponent,
    MenumasterComponent,
    MenuMasterComponent,
    MenumasterGridComponent,
    ReferenceMasterComponent,
    ReferenceDetailsComponent

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
      BrowserModule,
    MatSidenavModule,
    MatListModule,
    MatFormFieldModule,
    MatToolbarModule,
   MatInputModule,
   MatSelectModule,
    AppRoutingModule,
   FormsModule,
   BrowserAnimationsModule ,
   ReactiveFormsModule,
  ToastrModule.forRoot(),
    MatNativeDateModule,
    MatButtonModule,
    MatCardModule,
    MatIconModule,
    HttpClientModule,
     MatSnackBarModule,
    MatProgressSpinnerModule,
    MatCheckboxModule,
    InputTextModule, 
    ButtonModule

    
  ],
  providers: [],
  bootstrap: [AppComponent]
})
export class AppModule { }
